export default "__VITE_ASSET__Cg_dwajO__"